import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface UIState {
  navCollapsed: boolean;
  toggleNav: () => void;
  setNavCollapsed: (v: boolean) => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      navCollapsed: false,
      toggleNav: () => set((s) => ({ navCollapsed: !s.navCollapsed })),
      setNavCollapsed: (v) => set({ navCollapsed: v })
    }),
    {
      name: "whb-ui",
      storage: createJSONStorage(() => localStorage)
    }
  )
);
